import { checkResponse } from "../utils/checkResponse";
import { Channel, DomainAPI, getHeader } from "../utils/setting";

const voucher = {
  state: {
    voucherList: [],
    imgVoucherURL: "",
    selectedBranch: "",
    total: 0,
    count: 0,
    allVoucher: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changeSelectedBranch(state, payload) {
      state.selectedBranch = payload;
      return { ...state };
    },
    changeVoucherBranch(state, payload) {
      state.voucherList[payload.index].arrBranch = payload.data;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getVoucher(payload, rootState) {
      const _this = this;
      if (payload) payload.sort = [["createdAt", "DESC"]];
      return fetch(
        DomainAPI + Channel + "/api/secure/voucher/getVouchersForBranch",
        {
          method: "POST",
          headers: getHeader(true, rootState.user.token),
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              voucherList: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          } else {
            _this.setState({ voucherList: [] });
          }
          return result;
        })
        .catch((err) => {
          _this.setState({ voucherList: [] });
          return { code: 0, error: err, message: err.toString() };
        });
    },
    addNewVoucher(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/voucher/addNewVoucher";
      let vouchers = payload.data;
      vouchers.imgVoucher = payload.imgVoucherURL;
      vouchers.arrBranch = payload.arrBranch;

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(vouchers),
      })
        .then((res) => res.json())
        .then(function (response) {
          checkResponse(response);
          return response;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    updateVoucher(payload, rootState) {
      let vouchers = payload.voucher;
      vouchers.discount = Number(vouchers.discount);
      vouchers.arrBranch = payload.arrBranch;
      return fetch(DomainAPI + Channel + "/api/secure/voucher/updateVoucher", {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(vouchers),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    updateImageGallery(payload, rootState) {
      let vouchers = payload.voucher;

      return fetch(
        DomainAPI + Channel + "/api/secure/voucher/updateImageGallery",
        {
          method: "POST",
          headers: getHeader(true, rootState.user.token),
          body: JSON.stringify(vouchers),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    deleteVoucher(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/voucher/deleteVoucher";
      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          voucherCodes: payload.listVoucherDelete,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    searchVoucher(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/vouchers/searchVoucher";
      return fetch(url, {
        method: "GET",
        headers: getHeader(true, rootState.user.token),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ allVoucher: res.data });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
    },
  }),
};

export default voucher;
